import React from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../Components/Common/ChartsDynamicColor";

const YAxis = ({ dataColors, x, y1, y2, y3, y4 }) => {
  const chartMultiColors = ["#4b38b3", "#4CAF50", "#C62828"];

  const formatNumber = (num) => {
    return Intl.NumberFormat("en-US", {
      notation: "standard",
      maximumFractionDigits: 0,
    }).format(num);
  };

  const series = [
    {
      name: "Expected Income",
      type: "column",
      data: y1,
    },
    {
      name: "Actual Earnings",
      type: "column",
      data: y2,
    },
    {
      name: "Not Paid",
      type: "line",
      data: y3,
    },
  ];

  const options = {
    chart: {
      stacked: false,
      toolbar: { show: false },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [1, 1, 4],
    },
    title: {
      align: "left",
      offsetX: 110,
      style: {
        fontWeight: 600,
        color: "#000",
      },
    },
    xaxis: {
      categories: x,
    },
    yaxis: [
      {
        axisTicks: { show: true },
        axisBorder: { show: true, color: "#038edc" },
        labels: {
          style: { colors: "#038edc" },
          formatter: formatNumber,
        },
        title: {
          text: "Thousand €",
          style: { color: "#038edc", fontWeight: 600 },
        },
        tooltip: { enabled: true },
      },
      {
        seriesName: "Income",
        opposite: true,
        axisTicks: { show: true },
        axisBorder: { show: true, color: "#038edc" },
        labels: {
          style: { colors: "#038edc" },
          formatter: formatNumber,
        },
        title: {
          text: "Thousand €",
          style: { color: "#038edc", fontWeight: 600 },
        },
      },
    ],
    tooltip: {
      fixed: {
        enabled: true,
        position: "topLeft",
        offsetY: 30,
        offsetX: 60,
      },
      y: {
        formatter: formatNumber,
      },
    },
    legend: {
      horizontalAlign: "left",
      offsetX: 40,
    },
    colors: chartMultiColors,
  };

  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        className="apex-charts"
        options={options}
        series={series}
        type="line"
        height={350}
      />
    </React.Fragment>
  );
};

export { YAxis };
